import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { BundleSection } from './components/BundleSection';
import { SocialProofSection } from './components/SocialProofSection';
import { CheckoutSection } from './components/CheckoutSection';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Load Meta Pixel script
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1461755215622632');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-warm-white font-body selection:bg-gold selection:text-emerald-deep pt-[42px] md:pt-[52px]" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <RevelationSection data-id="element-4" />
      <BundleSection data-id="element-5" />
      <SocialProofSection data-id="element-6" />
      <CheckoutSection data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}